import { ClienteFincaLoteResponse } from "../../../../../modulos/terceros/response/ClienteFincaLoteResponse";
import { BaseFullScreenModalRender } from "../../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../../definitions/IConnectRender";
import { LotePickerMapRender } from "../map/LotePickerMapRender";

/** Modal full-screen que hospeda el picker de lote/potrero. Al elegir un lote,
 *  notifica (`onPick`) y se cierra. */
export class LotePickerModalRender extends BaseFullScreenModalRender {
  protected readonly elementId = "lotePickerModal";

  /**
   * @param _title          Título de la barra superior (p. ej. "Potrero destino").
   * @param _onPick         Handler que recibe el lote elegido.
   * @param _selectedLoteId Id del lote ya seleccionado (se resalta), o undefined.
   * @param _filter         Restringe qué lotes ofrece el picker, o undefined (todos).
   */
  constructor(
    private readonly _title: string,
    private readonly _onPick: (lote: ClienteFincaLoteResponse) => void,
    private readonly _selectedLoteId?: string,
    private readonly _filter?: (lote: ClienteFincaLoteResponse) => boolean,
  ) {
    super();
  }

  protected get title(): string {
    return this._title;
  }

  protected getContent(): IConnectRender {
    return new LotePickerMapRender(
      (lote) => {
        this._onPick(lote);
        this.dispose();
      },
      this._selectedLoteId,
      this._filter,
    );
  }
}
